// components/projects/EmptyState.tsx
import React from "react";
import { Briefcase, Clock, CheckCircle, Search } from "lucide-react";

interface EmptyStateProps {
  type: "available" | "pending" | "my_projects";
  hasFilters: boolean;
  onClearFilters: () => void;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  type,
  hasFilters,
  onClearFilters,
}) => {
  const config = {
    available: {
      icon: Briefcase,
      title: "No Projects Found",
      description: hasFilters
        ? "No projects match your current filters. Try adjusting your search criteria."
        : "There are no available projects at the moment. Check back soon!",
      gradient: "from-[#8B52FF] to-[#E05A6A]",
    },
    pending: {
      icon: Clock,
      title: "No Pending Applications",
      description: hasFilters
        ? "No pending applications match your filters."
        : "You haven't applied to any projects yet. Browse available projects to get started.",
      gradient: "from-amber-500 to-orange-500",
    },
    my_projects: {
      icon: CheckCircle,
      title: "No Active Projects",
      description: hasFilters
        ? "No projects match your current filters."
        : "You don't have any active projects. Apply to available projects and complete verification to get started.",
      gradient: "from-emerald-500 to-teal-500",
    },
  };

  const { icon: Icon, title, description, gradient } = config[type];

  return (
    <div className="py-16 px-6">
      <div className="max-w-sm mx-auto text-center">
        {/* Icon */}
        <div
          className={`w-20 h-20 mx-auto rounded-2xl bg-gradient-to-br ${gradient} flex items-center justify-center shadow-lg mb-6`}
        >
          {hasFilters ? (
            <Search className="w-10 h-10 text-white" />
          ) : (
            <Icon className="w-10 h-10 text-white" />
          )}
        </div>

        {/* Title */}
        <h3 className="text-xl font-bold text-gray-900 mb-2">{title}</h3>

        {/* Description */}
        <p className="text-gray-500 leading-relaxed mb-8">{description}</p>

        {/* Actions */}
        {/* <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          {hasFilters ? (
            <button
              onClick={onClearFilters}
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-[#8B52FF] to-[#E05A6A] text-white font-semibold rounded-xl shadow-lg shadow-purple-500/25 hover:shadow-xl hover:shadow-purple-500/30 hover:-translate-y-0.5 active:translate-y-0 transition-all duration-200"
            >
              Clear All Filters
            </button>
          ) : type !== "available" ? (
            <Link
              to="/projects"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-gradient-to-r from-[#8B52FF] to-[#E05A6A] text-white font-semibold rounded-xl shadow-lg shadow-purple-500/25 hover:shadow-xl hover:shadow-purple-500/30 hover:-translate-y-0.5 active:translate-y-0 transition-all duration-200 group"
            >
              Browse Available Projects
              <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
            </Link>
          ) : null}
        </div> */}
      </div>
    </div>
  );
};

export default EmptyState;
